import { axios } from '../../services/ServiceUtils';
import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { useLocation } from 'react-router';

const Footer = ({ language }) => {
  const [footer, setFooter] = useState("");
  const location = useLocation();

  const birdseed = (domNode) => {
    //Birdseed removed from pages other than home
    if (
      location.pathname !== '/' &&
      domNode.attribs && 
      domNode.attribs.class === 'ft-birdseed-section'
    )
      return <></>
  };

  useEffect(() => {
    const locale = language.locale.toLowerCase();
    const sessionStorageKey = `footer-html-${locale}`;
    const footerHtml = sessionStorage.getItem(sessionStorageKey);
    if (footerHtml) {
      setFooter(footerHtml);
    }
    else {
      axios
        .get(`api/masthead/footer/${locale}`)
        .then((result) => {
          sessionStorage.setItem(sessionStorageKey, result.data);
          setFooter(result.data);
        })
        .catch(e => {
          // eslint-disable-next-line
          console.error('request error', e);
        });
    }

  }, [language]);

  return (
    <>
      {parse(footer, {
        replace: function(domNode) {
          return birdseed(domNode);
        }
      })}
    </>
  );
};

export default Footer;
